import DefaultLayout from "../layouts/DefaultLayout";
import SortableDataTable from "../components/SortableDataTable";
import {useCallback, useEffect, useMemo, useState} from "react";
import ConfirmationModal from "./modals/ConfirmationModal";
import useTranslation from "../hooks/translations";
import IncomeCategoryModal from "./modals/IncomeCategoryModal";
import {TrendingUp} from "react-feather";
import {useApi} from "../contexts/ApiProvider";
import IncomeCategoryService from "../services/IncomeCategoryService";
import ProtectedContent from "../components/ProtectedContent";

export default function IncomeCategorySettingsPage() {
  const translations = useTranslation();
  const columns = [
    {
      name: translations.name,
      data_identifier: "name"
    },
    {
      name: translations.description,
      data_identifier: "description"
    },
    {
      name: translations.type,
      data_identifier: "type"
    },
  ];
  const pageTitle = translations.incomeCategory
  const pageSubtitle = translations.incomeCategoryPageSubtitle

  const api = useApi()
  const incomeCategoryService = useMemo(() => new IncomeCategoryService(api), [api]);

  const [openIncomeCategoryModal, setOpenIncomeCategoryModal] = useState(false);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [rows, setRows] = useState([]);

  const getData = useCallback(async () => {
    const response = await incomeCategoryService.getAll();
    const formatedResponse = response.body.map((row) => {
      return {
        id: row.id,
        name: row.name,
        description: row.description,
        type: row.type.name,
        typeId: row.type.id,
        order: row.order,
      }
    });
    setRows(formatedResponse);
  }, [incomeCategoryService])

  const reorderData = useCallback(async (data) => {
    const formatedRequest = data.map((row) => {
      return {
        id: row.id,
        order: data.indexOf(row) + 1
      }
    });
    await incomeCategoryService.reorder(formatedRequest);
  }, [incomeCategoryService])

  useEffect(() => {
    (async () => {
      await getData()
    })();
  }, [getData]);

  // datatable callbacks
  const onEditClick = async (data) => {
    setSelectedRow(data)
    setOpenIncomeCategoryModal(true)
  }

  const onDeleteClick = async (data) => {
    setSelectedRow(data)
    setOpenConfirmationModal(true)
  }

  const onAddClick = async () => {
    setOpenIncomeCategoryModal(true)
    setSelectedRow({})
  }

  const handleDragEnd = async (data) => {
    setRows(data)
    await reorderData(data)
  }

  // income category modal callbacks
  const onModalSubmit = async (data) => {
    await getData()
    setOpenIncomeCategoryModal(false)
  }

  const onModalClose = async () => {
    setOpenIncomeCategoryModal(false)
  }

  // confirmation modal callbacks
  const onConfirmationModalSubmit = async (data) => {
    await incomeCategoryService.delete(data.id)
    await getData()
    setOpenConfirmationModal(false)
  }

  const onConfirmationModalClose = async () => {
    setOpenConfirmationModal(false)
  }

  return (
    <DefaultLayout icon={<TrendingUp/>}
                   title={pageTitle}
                   subtitle={pageSubtitle}>
      <ProtectedContent
        allowedRoles={["Admin"]}
        alt={<div style={{textAlign: "center", margin: 10}}>
          <h1>{translations.permissionsAlert}</h1></div>}>
        <SortableDataTable title={pageTitle}
                           columns={columns}
                           rows={rows}
                           editAction={onEditClick}
                           deleteAction={onDeleteClick}
                           addAction={onAddClick}
                           dragEndAction={handleDragEnd}/>
        {openIncomeCategoryModal &&
          <IncomeCategoryModal data={selectedRow}
                               title={pageTitle}
                               onModalSubmit={onModalSubmit}
                               onModalClose={onModalClose}
                               showModal={openIncomeCategoryModal}/>
        }
        {openConfirmationModal &&
          <ConfirmationModal data={selectedRow}
                             onConfirmationModalSubmit={onConfirmationModalSubmit}
                             onConfirmationModalClose={onConfirmationModalClose}
                             showModal={openConfirmationModal}/>
        }
      </ProtectedContent>
    </DefaultLayout>
  )
}
